import { Transfer } from 'antd'
import React, { useState } from 'react'

import { useFetchedOptions } from '@app/hooks'

import { filterOption, render } from './utils'
import { DEFAULT_TITLES, DEFAULT_LOCALE, DEFAULT_PAGINATION, DEFAULT_LIST_STYLES } from './constants'

import type { ReactElement } from 'react'
import type { LntTransferProps, LntTransferItem, LntTransferDirection } from './types'

const Component = <QueryResponseResultType = unknown,>(
  props: LntTransferProps<QueryResponseResultType>
): ReactElement<LntTransferProps<QueryResponseResultType>> => {
  const {
    dataSource: defaultOptions,
    targetKeys: outerTargetKeys,
    titles = DEFAULT_TITLES,
    locale = DEFAULT_LOCALE,
    listStyle = DEFAULT_LIST_STYLES,
    pagination = DEFAULT_PAGINATION,
    queryOptions,
    onChange,
    ...restProps
  } = props

  const { fetchedOptions, isLoading } = useFetchedOptions<LntTransferItem, QueryResponseResultType>({
    defaultOptions,
    queryOptions
  })

  const [targetKeys, setTargetKeys] = useState<string[]>([])

  const handleChange = (targetKeys: string[], transferDirection: LntTransferDirection, moveKeys: string[]): void => {
    setTargetKeys(targetKeys)
    onChange?.(targetKeys, transferDirection, moveKeys)
  }

  return (
    <Transfer
      { ...restProps }
      dataSource={ fetchedOptions }
      targetKeys={ outerTargetKeys ?? targetKeys }
      titles={ titles }
      locale={ locale }
      listStyle={ listStyle }
      pagination={ pagination }
      disabled={ isLoading }
      filterOption={ filterOption }
      render={ render }
      showSearch
      onChange={ handleChange }
    />
  )
}

export const LntTransfer = React.forwardRef((props, ref) => <Component { ...props } />) as typeof Component
